var _excluded = ["title", "required", "description", "placeholder", "fieldName", "validation", "className", "wrapperClassName", "disabled", "minDate", "maxDate", "onChange", "includeFieldSet", "calendarStartDay", "locale"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import enUS from 'date-fns/locale/en-US';
import nl from 'date-fns/locale/nl';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import GenericFormElement from '../GenericFormElement';
import { useExtendedFormikContext } from '../FormikWrapper';
import 'react-datepicker/dist/react-datepicker.css';
import './style.scss';
var DatePicker = function DatePicker(props) {
  var title = props.title,
    required = props.required,
    description = props.description,
    placeholder = props.placeholder,
    fieldName = props.fieldName,
    validation = props.validation,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    minDate = props.minDate,
    maxDate = props.maxDate,
    _onChange = props.onChange,
    includeFieldSet = props.includeFieldSet,
    _props$calendarStartD = props.calendarStartDay,
    calendarStartDay = _props$calendarStartD === void 0 ? 1 : _props$calendarStartD,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? 'nl' : _props$locale,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useExtendedFormikCon = useExtendedFormikContext(),
    values = _useExtendedFormikCon.values,
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    setFieldValue = _useExtendedFormikCon.setFieldValue,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isTouched = touched[fieldName];
  var value = values[fieldName];
  var error = errors[fieldName];
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && !value) {
      return t(['webform.components.date_picker.required', 'webform.required', 'webform_required']);
    }
    if (minDate && new Date(value).getTime() < new Date(minDate).getTime()) {
      return t(['webform.components.date_picker.min', 'webform.min', 'webform_min'], {
        date: value,
        minDate: minDate
      });
    }
    if (maxDate && new Date(value).getTime() > new Date(maxDate).getTime()) {
      return t(['webform.components.date_picker.max', 'webform.max', 'webform_max'], {
        date: value,
        maxDate: maxDate
      });
    }
  };
  registerLocale('en', enUS);
  registerLocale('nl', nl);

  // Changing locales breaks the test suite in horrible ways
  if (process.env.NODE_ENV !== 'test') {
    setDefaultLocale(locale);
  }
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('DatePicker', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: isTouched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator,
    errorId: errorId,
    descriptionId: descriptionId,
    includeFieldSet: includeFieldSet
  }, /*#__PURE__*/React.createElement(Field, {
    id: fieldName,
    name: fieldName,
    validate: handleValidation,
    fieldName: fieldName,
    touched: touched,
    error: error,
    value: value
  }, function () {
    return /*#__PURE__*/React.createElement(ReactDatePicker, _extends({
      selected: value && new Date(value) || null,
      onChange: function onChange(value) {
        setFieldValue(fieldName, value);
        if (_onChange) _onChange(value);
      },
      peekNextMonth: true,
      showMonthDropdown: true,
      showYearDropdown: true,
      dropdownMode: "select",
      id: fieldName,
      name: fieldName,
      className: className,
      disabled: disabled,
      required: required,
      placeholderText: placeholder,
      calendarStartDay: calendarStartDay
    }, restProps));
  }));
};
export default DatePicker;